import CorreJunto from '@mui/icons-material/DirectionsRun';
import { makeObservable, observable } from 'mobx';
import { Filtro } from './Filtro';

export default class FiltroCorreJunto extends Filtro {
    tipo = 'booleano';
    exibicao = 'checkbox';

    get label() {
        return 'Com corre junto';
    }

    getIconeFiltroRapido() {
        return <CorreJunto />;
    }

    constructor(props) {
        super(props);

        makeObservable(this, {
            filtroRapido: observable
        });
    }

    filtroRapido = {
        valor: true
    };

    getValorOpcao(registro) {
        return Array.isArray(registro?.processo?.correJuntos) && registro.processo.correJuntos.length > 0;
    }

    getDescricao(valor) {
        return this.labelBooleanoSimNao(valor);
    }
}
